import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_5: FaireProductEntity = {
  token: "pom-pom-5",
  type: "product",
  name: "Popcorn, Caramel",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e9736563c3753dc76d00b37ef7dbd7badc1eb5e9fa90d6c5649e2c9f260c6383.jpeg",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
